import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AddressView } from "../../parameters/AddressView";
const PriceUpdates = ({ priceUpdates }) => {
    if (!priceUpdates?.length) {
        return null;
    }
    return (_jsxs("div", { className: "grid grid-cols-values-2 border", children: [_jsx("div", { className: "w-64 font-bold p-2 border-r", children: "Price Updates" }), _jsx("div", { className: "flex flex-col p-2 gap-y-1", children: priceUpdates.map(({ priceFeed }) => (_jsx(AddressView, { address: priceFeed, compact: true }, priceFeed))) })] }));
};
export default PriceUpdates;
